import React from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ApolloProvider } from "@apollo/client";
import { client } from "./api/gql";

import RegistrationRoutes from "./routes";
import { ModalProvider, Modal } from "./components/common";
import {
  DrawerProvider,
  BreakpointProvider,
  MobileProvider,
  OverlayProvider,
  LayoutProvider,
} from "./components/common/wrappers";
import { shouldHotjarScriptLoad } from "./utilities/hotjar";
import "./App.css";
import "./config/config";

const App = ({ history: { push, goBack } }) => {
  const hasPageMounted = localStorage.getItem("hasPageMounted");
  if (!hasPageMounted) {
    localStorage.setItem("hasPageMounted", "true");
  }
  return (
    <ApolloProvider client={client}>
      <div className="App">
        <Helmet>
          <script src="https://connect2.finicity.com/assets/sdk/finicity-connect.min.js" />
        </Helmet>
        <MobileProvider>
          <BreakpointProvider>
            <DrawerProvider>
              <ModalProvider>
                <OverlayProvider>
                  <LayoutProvider>
                    <RegistrationRoutes />
                    <Modal />
                  </LayoutProvider>
                </OverlayProvider>
              </ModalProvider>
            </DrawerProvider>
          </BreakpointProvider>
        </MobileProvider>
      </div>
    </ApolloProvider>
  );
};

export default withRouter(App);
